import { Alert } from "@mantine/core"
import { PropsWithChildren } from "react"

interface Props extends PropsWithChildren {
  title: string
  description?: React.ReactNode
}

export function SuccessAlert({ title, description, children }: Props) {
  return (
    <Alert color="green" title={title}>
      {description}
      {children}
    </Alert>
  )
}
